module.exports = __webpack_public_path__ + "static/atbdx-d82297a6213c63da8d3fdc4dfc899626.png";